//@flow

import React from 'react';
import { Link } from 'react-router-dom';
import { NavItem } from 'reactstrap';

type Props = {
  text: string,
  url: string,
  active: boolean,
  rel: string,
  dropdownToggle?: () => void,
};

export default function Tab(props: Props) {
  const { text, url, active, dropdownToggle = () => {} } = props;

  return (
    <NavItem>
      <Link
        className={active ? 'active' : ''}
        to={url}
        title={text}
        onClick={dropdownToggle}
      >
        {text}
      </Link>
    </NavItem>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTabs/Tabs.jsx